import {useEffect, useMemo, useRef} from 'react'
import {useLocation, useNavigate, useParams} from 'react-router'
import styles from './DialogHeader.module.scss'
import {cx} from '../../../../utils'
import {ReactComponent as LeftArrow} from '../../../../assets/Icons/LeftArrow.svg'
import {ReactComponent as Eye} from '../../../../assets/Icons/Eye.svg'
import {ReactComponent as Copy} from '../../../../assets/Icons/Copy.svg'
import {userConversationsPath} from '../../../../constants/pathConstants'
import {homeActions} from '../../../../store/home/homeActions'
import {dialogApi} from '../../../../api/dialogApi'
import {useWuShowToast, WuInput} from '@npm-questionpro/wick-ui-lib'
import {useWt} from '@npm-questionpro/wick-ui-lib'
import {GLOBAL} from '../../../../Translation/English/global'
import {DIALOG} from '../../../../Translation/English/dialog'

interface ILocationState {
  isArchiveTab?: boolean
}

export const DialogHeader: React.FC = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const setBreadcrumb = homeActions.useSetBreadcrumb()
  const wt = useWt()
  const {showToast} = useWuShowToast()
  const dialogURL = useRef<HTMLInputElement>(null)
  const {isArchiveTab} = (location.state as ILocationState) || {}
  const {dialogId} = useParams<{dialogId: string}>()
  const {data: dialogDetails} = dialogApi.useDialogDetails(dialogId ?? '')

  useEffect(() => {
    setBreadcrumb([
      {label: wt(GLOBAL.conversations), path: `/conversations`},
      {label: dialogDetails?.title ?? '', path: ''},
    ])
  }, [dialogDetails?.title, setBreadcrumb, wt])

  useEffect(() => {
    return (): void => {
      setBreadcrumb([])
    }
  }, [setBreadcrumb])

  const userURL = useMemo(() => {
    return (
      window.location.origin + userConversationsPath + (dialogDetails?.id ?? '')
    )
  }, [dialogDetails?.id])

  const copyUrl = (): void => {
    dialogURL.current?.select()
    showToast({message: wt(DIALOG.urlCopied), variant: 'success'})
    navigator.clipboard.writeText(userURL)
  }

  return (
    <div className={styles.dialogHeader}>
      <div className={styles.dialogHeaderTitleBlock}>
        <LeftArrow
          onClick={() =>
            navigate(
              `/conversations?view=${isArchiveTab ? 'closed' : 'active'}`,
            )
          }
        />
        <div>{dialogDetails?.title}</div>
        <div
          className={cx(
            styles.dialogHeaderStatus,
            isArchiveTab ? styles.dialogHeaderRed : styles.dialogHeaderGreen,
          )}
        >
          {isArchiveTab ? wt(GLOBAL.closed) : wt(GLOBAL.active)}
        </div>
      </div>
      {!isArchiveTab && (
        <div className={styles.dialogHeaderLinkBlock}>
          <div className={styles.dialogHeaderUrlBlock} onClick={copyUrl}>
            <WuInput
              className={styles.dialogHeaderUrlLink}
              value={userURL}
              ref={dialogURL}
              readOnly
            />
            <div className={styles.dialogHeaderCopy}>
              <Copy />
            </div>
          </div>
          <a
            href={userURL}
            target="_blank"
            className={styles.dialogHeaderPreview}
            rel="noreferrer"
          >
            <Eye />
          </a>
        </div>
      )}
    </div>
  )
}
